import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" fill="none" fillRule="evenodd"><path d="M3.5 4.5h17l-6.4 7.4c-.4.4-.6.9-.6 1.4v5.2l-3 2v-7.2c0-.5-.2-1-.6-1.4L3.5 4.5z" /><path d="M17 17l4 4m0-4l-4 4" strokeLinecap="round" /></g></svg>;